import { render, staticRenderFns } from "./ModalAsociaMenu.vue?vue&type=template&id=47eed94a"
import script from "./ModalAsociaMenu.vue?vue&type=script&lang=js"
export * from "./ModalAsociaMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports